import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import VideocamIcon from '@material-ui/icons/Videocam';

const useStyles = makeStyles((theme: Theme) => {
  return {
    activitiesContainer: {
      padding: theme.spacing(),
      '& > div:last-child': {
        marginBottom: 0
      }
    },
    activityCard: {
      width: '100%',
      border: '1px solid #EAEAEA',
      marginBottom: theme.spacing(),
      borderRadius: 4,
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0 1px 8px 4px rgba(0, 0, 0, 0.20)',
        backgroundColor: theme.palette.grey[100]
      }
    },
    activityCardImage: {
      width: '100%'
    },
    activityName: {
      color: theme.palette.secondary.main,
      fontWeight: 500
    },
    activityDetails: {
      fontWeight: 500
    },
    activityCardActionsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderTop: '1px solid #EAEAEA',
      padding: theme.spacing()
    },
    activityCardAction: {
      display: 'flex',
      alignItems: 'center'
    },
    iconButton: {
      width: 36,
      height: 36,
      minWidth: 'unset',
      padding: 'unset'
    },
    icon: {
      height: 18,
      width: 18
    }
  };
});

type ActivityCardProps = {
  name: string;
  subtitle: string;
  thumbnail?: string;
  videoUrl?: string;
  url: string;
};

const ActivityCard: React.FC<ActivityCardProps> = ({
  name,
  subtitle,
  thumbnail,
  videoUrl,
  url
}) => {
  const classes = useStyles();

  const handleVideoIconClick = (e: any): void => {
    e.stopPropagation();
    window.open(videoUrl, '_blank');
  };

  const handleActivityCardClick = (): void => {
    window.open(url, '_blank');
  };

  return (
    <div className={classes.activityCard} onClick={handleActivityCardClick}>
      {thumbnail && (
        <img src={thumbnail} className={classes.activityCardImage} alt="Activity Card" />
      )}
      <div className={classes.activityCardActionsContainer}>
        <div>
          <Typography className={classes.activityName}>{name}</Typography>
          <Typography className={classes.activityDetails}>{subtitle}</Typography>
        </div>
        <div className={classes.activityCardAction}>
          {videoUrl && (
            <Button
              variant="outlined"
              size="small"
              color="secondary"
              disableElevation
              className={classes.iconButton}
            >
              <VideocamIcon onClick={handleVideoIconClick} className={classes.icon} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;
